@if (shouldShowAiMarkerSection()) {
	<section class="form-group ai-markers-group" [ngClass]="{ 'empty': !hasDefinitions }">
		<ng-container *ngIf="!hasDefinitions; else hasAiMarkers">
			<section>
				<span class="ai-markers-btn-group">
					<button
						type="button"
						class="link-btn add-btn ai-markers-btn"
						aria-label="{{'activity-editor-new_ai-markers_aria-label' | translate}}"
						(click)="openAiMarkers()">
						<span translate="activity-editor-new_ai-markers"></span>
						<i class="ficon-sparkles" aria-hidden="true"></i>
					</button>
					<badge
						*ngIf="shouldShowAdvancedPlanBadge()"
						class="advanced-plan-badge"
						[badgeLabel]="'common_advanced-plan' | translate"
						[badgeColor]="badgeColors.SUCCESS">
					</badge>
				</span>
			</section>
		</ng-container>

		<ng-template #hasAiMarkers>
			<ai-marker-set-panel
				class="ai-markers-set"
				[llmDefinitions]="llmDefinitions"
				[canPreview]="canPreviewAiPrompts"
				(onEdit)="openAiMarkers()"
				(onRemove)="removeAiMarkerSet()"
				(onPreview)="previewAiMarkers()">
			</ai-marker-set-panel>
		</ng-template>
	</section>
}
